"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemEvent = exports.SystemEventLevel = void 0;
var system_event_1 = require("@shared-ui/logger-context/dist/commonjs/components/system-event");
Object.defineProperty(exports, "SystemEventLevel", {
  enumerable: true,
  get: function () {
    return system_event_1.SystemEventLevel;
  }
});
Object.defineProperty(exports, "SystemEvent", {
  enumerable: true,
  get: function () {
    return system_event_1.SystemEvent;
  }
});